<style lang="scss">
.refund {
    .footer {
        text-align: center;
    }
    .custom-class {
        width: 600px;
    }
}
</style>
<template>
    <div class="refund">
        <el-dialog
            title="退款申请"
            :visible.sync="myResult"
            label-width="0px"
            custom-class="custom-class"
        >
            <el-form
                ref="form"
                :model="form"
                label-width="150px"
                :rules="rules"
            >
                <el-form-item
                    label="选择科目"
                    prop="subject"
                >
                    <el-checkbox-group v-model="form.subject">
                        <el-checkbox
                            :label="subject.subject_id"
                            v-for="subject in subjects"
                            :key="subject.subject_id"
                        >
                            {{subject.subject_name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item
                    label="填写退费原因"
                    prop="text"
                >
                    <el-input
                        v-model="form.text"
                        type="textarea"
                        :rows="4"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="footer">
                <el-button
                    type="primary"
                    @click="myResult=false"
                >取消
                </el-button>
                <el-button
                    type="primary"
                    @click="postRefund('form')"
                >提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data: function() {
        return {
            myResult: false,
            subjects: [],
            form: { text: "", subject: [] },
            rules: {
                subject: [
                    {
                        type: "array",
                        required: true,
                        message: "请至少选择一个科目",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        regId: String
    },
    watch: {
        dialogFormVisible(val) {
            this.myResult = val;
            if (val) {
                this.getData();
            } else {
                this.$refs.form.resetFields();
            }
        },
        myResult(val) {
            this.$emit("on-result-change", val);
        }
    },
    methods: {
        getData: function() {
            this.$http
                .get(globalProvider.serviceUrl("e_reg/g/roi/{regId}"), {
                    params: { regId: this.regId }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        this.subjects = data.body.data;
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message));
                    }
                });
        },
        postRefund: function(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$http
                        .post(
                            globalProvider.serviceUrl("e_reg/u/roi"),
                            {
                                reg_id: this.regId,
                                subject_ids: this.form.subject,
                                note: this.form.text
                            },
                            { params: { loading: true } }
                        )
                        .then(data => {
                            if (data.body.code === resultCode.Success) {
                                this.$alert("退款申请成功");
                                this.myResult = false;
                            } else if (
                                data.body.code == resultCode.NotSuccess
                            ) {
                                this.$alert(getErrorMessage(data.body.message));
                            }
                        });
                }
            });
        }
    }
};
</script>